<app-base-page pageTitle="Logos"
	[pageContext]="pageContext"
	utilityMenuOperationGroupName="">
	<div class="ui-g-12">
	</div>
</app-base-page>